import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import Route, {
  TransferStopsPayload,
  TransferStopsResponse,
} from "@mapmycustomers/shared/types/entity/Route";

export const showMoveStops = createAction("route/moveStops/show")<{ sourceRoute: Route }>();

export const hideMoveStops = createAction("route/moveStops/hide")();

export const fetchDestinationRoutes = createAsyncAction(
  "route/moveStops/fetchDestinationRoutes/request",
  "route/moveStops/fetchDestinationRoutes/success",
  "route/moveStops/fetchDestinationRoutes/failure"
)<{ query?: string }, Route[], void>();

export const transferStops = createAsyncAction(
  "route/moveStops/transfer/request",
  "route/moveStops/transfer/success",
  "route/moveStops/transfer/failure"
)<TransferStopsPayload & { callback?: () => void }, TransferStopsResponse, void>();

export type MoveStopsActions = ActionType<
  typeof fetchDestinationRoutes | typeof hideMoveStops | typeof showMoveStops | typeof transferStops
>;
